module.exports = __webpack_public_path__ + "img/back.b7c3d21d.svg";